import { render, staticRenderFns } from "./ReviewCaseEditableDetail.vue?vue&type=template&id=c2758f86&scoped=true"
import script from "./ReviewCaseEditableDetail.vue?vue&type=script&lang=js"
export * from "./ReviewCaseEditableDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewCaseEditableDetail.vue?vue&type=style&index=0&id=c2758f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2758f86",
  null
  
)

export default component.exports